@if (isOpen()) {
  <div
    class="auth-modal-backdrop"
    (click)="onBackdropClick($event)"
  >
    <div
      #dialog
      class="auth-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="auth-modal-title"
    >
      <header class="auth-modal__header">
        <div class="auth-modal__brand">
          <img
            src="/images/logo/logo.png"
            alt=""
            class="auth-modal__logo"
            aria-hidden="true"
          />
          <h2 id="auth-modal-title" class="auth-modal__title">{{ titleFor() }}</h2>
        </div>
        <button
          type="button"
          class="auth-modal__close"
          aria-label="Cerrar"
          (click)="onCloseClick()"
        >
          <app-icon [icon]="closeIcon" [size]="20" color="currentColor" />
        </button>
      </header>

      <div class="auth-modal__body">
        @switch (mode()) {
          @case ('login') {
            <app-login-form />
          }
          @case ('register') {
            <app-register-form />
          }
          @case ('forgot') {
            <app-forgot-password-form />
          }
          @case ('check-email') {
            <div class="auth-modal__check-email">
              <span class="auth-modal__check-email-icon" aria-hidden="true">
                <app-icon [icon]="mailCheckIcon" [size]="48" color="currentColor" />
              </span>
              <p class="auth-modal__check-email-text">
                Te enviamos un enlace de verificación a
                <strong>{{ registeredEmail() }}</strong>. Ábrelo desde cualquier
                dispositivo para activar tu cuenta.
              </p>
              <app-button variant="primary" size="md" (click)="onCheckEmailDone()">
                Entendido
              </app-button>
              <button
                type="button"
                class="auth-modal__link"
                (click)="switchToLogin()"
              >
                Ya verifiqué, iniciar sesión
              </button>
            </div>
          }
        }
      </div>
    </div>
  </div>
}
